import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
} from '@mui/material';
import { useAnnotationDialogsContext } from '../../AnnotationDialogsContext';
import { useCallback } from 'react';
import { useUserRelatedDocumentContext } from '../../../../components/DocumentUserRelatedContext';

export default function Dialog() {
  const { isDeleteDialogOpen, closeDeleteDialog, selectedAnnotation } =
    useAnnotationDialogsContext();
  const { removeAnnotation } = useUserRelatedDocumentContext();

  const handleAnnotationDelete = useCallback(() => {
    if (selectedAnnotation) {
      // TODO: Send annotation Delete request to backend

      // Then delete from local state
      removeAnnotation(selectedAnnotation);
    }

    closeDeleteDialog();
  }, [removeAnnotation, closeDeleteDialog, selectedAnnotation]);

  return (
    <MuiDialog
      open={isDeleteDialogOpen}
      onClose={closeDeleteDialog}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>Poista merkintä</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Haluatko varmasti poistaa merkinnän?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='error'
          onClick={handleAnnotationDelete}
        >
          Poista
        </Button>
        <Button variant='outlined' onClick={closeDeleteDialog}>
          Peruuta
        </Button>
      </DialogActions>
    </MuiDialog>
  );
}
